import { http } from './http';
import { toast } from 'sonner';

// Helper to convert base64 string to Uint8Array
function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function initializePushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push messaging is not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('Service Worker registered successfully.');
    
    // Wait for the worker to be active
    await navigator.serviceWorker.ready;
    
    let subscription = await registration.pushManager.getSubscription();

    if (subscription === null) {
      const permission = await window.Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('Notification permission not granted.');
        return;
      }

      const response = await http<{ publicKey: string }>('/api/push/vapid-public-key', {
        sendProjectId: false,
      });
      const publicKey = response.publicKey;

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });

      console.log('New Push Subscription created.');
      
      await http('/api/push/subscribe', {
        method: 'POST',
        body: JSON.stringify({
          subscription: subscription.toJSON(),
          origin: window.location.origin,
        }),
        sendProjectId: false,
      });

      toast.success("Push notifications enabled!");
    } else {
      console.log('User is already subscribed to push notifications.');
    }
  } catch (error) {
    console.error('Failed to initialize push notifications:', error);
    toast.error("Could not enable push notifications.", {
        description: "You may need to enable them in your browser settings."
    });
  }
}